<template>
  <div class="statistics-filters">
    <div class="row g-3">
      <div class="col-lg-4 col-md-6">
        <label class="form-label" for="user-statistics-search">用户查询</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-search"></i></span>
          <input
            id="user-statistics-search"
            type="search"
            class="form-control"
            placeholder="用户名、姓名或邮箱"
            :value="searchQuery"
            @input="emitValue('update:searchQuery', $event)"
          >
        </div>
      </div>
      <div class="col-lg-2 col-md-3">
        <label class="form-label" for="user-statistics-role">角色</label>
        <select
          id="user-statistics-role"
          class="form-select"
          :value="roleFilter"
          @change="emitValue('update:roleFilter', $event)"
        >
          <option value="">所有角色</option>
          <option v-for="role in roleOptions" :key="role.id" :value="role.name">
            {{ roleLabel(role.name) }}
          </option>
        </select>
      </div>
      <div class="col-lg-2 col-md-3">
        <label class="form-label" for="user-statistics-status">账户状态</label>
        <select
          id="user-statistics-status"
          class="form-select"
          :value="statusFilter"
          @change="emitValue('update:statusFilter', $event)"
        >
          <option value="">所有状态</option>
          <option value="active">启用</option>
          <option value="inactive">禁用</option>
        </select>
      </div>
      <div class="col-lg-2 col-md-6">
        <label class="form-label" for="user-statistics-date-field">日期口径</label>
        <select
          id="user-statistics-date-field"
          class="form-select"
          :value="dateField"
          @change="emitValue('update:dateField', $event)"
        >
          <option value="createdAt">注册日期</option>
          <option value="lastActiveTime">最后活跃</option>
        </select>
      </div>
      <div class="col-lg-2 col-md-6 d-flex align-items-end">
        <button type="button" class="btn btn-outline-secondary w-100" @click="$emit('reset')">
          重置条件
        </button>
      </div>
      <div class="col-lg-3 col-md-6">
        <label class="form-label" for="user-statistics-start-date">开始日期</label>
        <input
          id="user-statistics-start-date"
          type="date"
          class="form-control"
          :value="startDate"
          :max="endDate || undefined"
          @input="emitValue('update:startDate', $event)"
        >
      </div>
      <div class="col-lg-3 col-md-6">
        <label class="form-label" for="user-statistics-end-date">结束日期（含当天）</label>
        <input
          id="user-statistics-end-date"
          type="date"
          class="form-control"
          :value="endDate"
          :min="startDate || undefined"
          @input="emitValue('update:endDate', $event)"
        >
      </div>
      <div class="col-lg-6 d-flex align-items-end">
        <p class="filter-hint mb-2">
          统计口径：刷题数仅累计已完成会话题数；错题数为当前未掌握错题；最后活跃为最近一次刷题会话开始时间。
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Role } from '@/api/users'
import type { UserDateField } from '@/types/user-statistics'

defineProps<{
  searchQuery: string
  roleFilter: string
  statusFilter: string
  dateField: UserDateField
  startDate: string
  endDate: string
  roleOptions: Role[]
}>()

const emit = defineEmits<{
  (event: 'update:searchQuery', value: string): void
  (event: 'update:roleFilter', value: string): void
  (event: 'update:statusFilter', value: string): void
  (event: 'update:dateField', value: UserDateField): void
  (event: 'update:startDate', value: string): void
  (event: 'update:endDate', value: string): void
  (event: 'reset'): void
}>()

const emitValue = (event: string, source: Event) => {
  const value = (source.target as HTMLInputElement | HTMLSelectElement).value
  emit(event as any, value)
}

const roleLabel = (role: string) => role === 'admin' ? '管理员' : role === 'user' ? '普通用户' : role
</script>

<style scoped>
.statistics-filters {
  padding: 1.25rem;
  background: #fff;
  border: 1px solid #dbeafe;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.05);
}

.form-label {
  color: #334155;
  font-size: 0.85rem;
  font-weight: 600;
}

.filter-hint {
  color: #64748b;
  font-size: 0.82rem;
  line-height: 1.55;
}
</style>
